<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-icon-button (click)="drawer.toggle()" color="primary">
    <mat-icon>{{ drawer.opened ? "close" : "menu" }}</mat-icon>
  </button>

  <div>
    <!-- <button mat-icon-button (click)="logout()">
      <mat-icon>notifications_none</mat-icon>
    </button> -->

    <button mat-icon-button (click)="logout()" color="warn">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</mat-toolbar>
